import { render, staticRenderFns } from "./CuponsChart.vue?vue&type=template&id=60edfdb4"
import script from "./CuponsChart.vue?vue&type=script&lang=js"
export * from "./CuponsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports